module.exports = __webpack_public_path__ + "static/img/nicolefrey_circle150.776f3a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/experts/nicolefrey_circle150.png
// module id = zU3l
// module chunks = 0